/**************************************************
 * Nombre:       Seccion_Prueba
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {Checkroom, ManageSearch} from '@mui/icons-material'
import {
    CASILLA_CONTAR_ARR,
    CASILLA_FECHA_DATOS,
    CASILLA_IMG_PRIMERA_ARR
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useEffect, useState} from "react";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Configuraciones from "../Formularios/Formulario_Configuraciones";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {subirPdfHostingFile} from "../../Servicios/AlmacenamientoHosting/subirPdfHostingFile";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {guardarFecha} from "../../Servicios/Local/guardarFecha";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {guardarFechaAct} from "../../Servicios/BD/Actualizadores/guardarFechaAct";


const Seccion_Configuraciones = () => {
    const {sCell} = useResponsive()
    const {props, obtenerEntidad, setEntidad} = useFormulario({valoresDefecto: {}})
    const {Avisos, nuevoAviso, terminar} = useCargador({direccion: 'right'})
    const [cargando, setCargando] = useState(false)


    const guardarCambios = async () => {

        let entidad = await obtenerEntidad()
        entidad.id = 'generales'
        nuevoAviso({aviso: 'guardando datos'})

        let doxPdf = await subirPdfHostingFile(entidad.guia_tallas)
        if (doxPdf.res) {
            entidad.guia_tallas = doxPdf.data
            nuevoAviso({aviso: 'pdf subido'})
        }

        let doxEmergente = await subirImagenHostingFile(entidad.imgEmergente)
        entidad.imgEmergente = doxEmergente.data

        let doxSuperiro = await subirImagenHostingFile(entidad.imgSuperior)
        entidad.imgSuperior = doxSuperiro.data

        let doxInferior = await subirImagenHostingFile(entidad.imgInferior)
        entidad.imgInferior = doxInferior.data

        let doxAccesorios = await subirImagenHostingFile(entidad.imgAccesorios)
        entidad.imgAccesorios = doxAccesorios.data


        let dox = await guardarDoc('configuraciones', entidad)

        if (dox.res) {
            await guardarFechaAct('configuraciones')
            terminar({aviso: 'Configuracion guardada'})
            setCargando(false)


        } else {
            terminar({aviso: 'Algo inesperado paso, intentalo nuevamente', variante: 'error'})
            setCargando(false)
        }


    }

    useEffect(() => {
        obtenerDoc('configuraciones', 'generales').then((dox) => {
            if (dox.res) {
                setEntidad(dox.data)
            }
        })
    }, []);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Avisos/>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1400px', px: sCell ? 1 : 4}}
                spacing={3}
            >

                <Grid container size={{xs: 12, sm: 12, md: 6}} justifyContent={'flex-start'}>
                    <Typography sx={{fontSize: 24, fontWeight: 800}}>Configuraciones Generales</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}} justifyContent={'flex-end'}>
                    <Button
                        onClick={() => guardarCambios()}
                        loading={cargando}>Guardar Cambios</Button>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>
                    <Formulario_Configuraciones props={props}/>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Seccion_Configuraciones

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    }
]


const datosCabecera = [
    {
        nombre: 'Portada',
        direccion: 'left',
        propiedad: 'imgs',
        tipo: CASILLA_IMG_PRIMERA_ARR

    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedades: ['coleccion'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS

    },
    {
        nombre: '# Prendas',
        direccion: 'left',
        propiedad: 'productos',
        tipo: CASILLA_CONTAR_ARR
    }


]


const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'Prendas',
        id: 'prendas',
        icono: Checkroom
    }
]


